<div class="accordion accordion-custom" id="faqAccordion">
  <div class="accordion-item" *ngFor="let item of resolvedFaqs; let i = index">
    <h2 class="accordion-header">
      <button 
        class="accordion-button collapsed" 
        type="button" 
        data-bs-toggle="collapse" 
        [attr.data-bs-target]="'#collapse' + i" 
        aria-expanded="false">
        {{ item.title }}
      </button>
    </h2>
    <div 
      [id]="'collapse' + i" 
      class="accordion-collapse collapse">
      <div class="accordion-body" [innerHTML]="item.description">
      </div>
    </div>
  </div>
</div>